import { GameLocation as GameLocationClass, GameStatus as GameStatusClass } from 'trill-api-admin-client'

export const GameLocation = new GameLocationClass()
export const GameStatus = new GameStatusClass()
